import { type SearchRequest } from '@searchkit/api';

type SearchRequestParams = NonNullable<NonNullable<SearchRequest['request']>['params']>;

export function withRequestParams(source: SearchRequest, patch: Partial<SearchRequestParams>): SearchRequest {
  return {
    ...source,
    request: {
      ...source.request,
      params: {
        ...(source.request?.params ?? {}),
        ...patch,
      },
    },
  };
}
